module.exports = __webpack_public_path__ + "img/logoBureaus.83ab9770.png";